import React from 'react';
import { CartesianGrid, LineChart, Line, XAxis, YAxis, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import KnotchGraph from '@bit/knotchinc.web-react-components.graphs.knotch-graph';
import { dateTickFormatter } from 'helpers/GraphUtils.js';
import { GraphContainer } from 'components/Graphs/styled.js';
import { EntityLegend, getEntityName } from 'components/Graphs/GraphHelpers.js';

// check if any data is > 0 with the exception of the xaxis
const validateTimeseries = ({ data, xaxis }) => {
  const sumValues = (object) => {
    let acc = 0;
    for (const prop in object) {
      if (prop !== xaxis) acc += object[prop];
    }
    return acc;
  };

  return data && data.reduce((acc, curr) => (acc += sumValues(curr)), 0) > 0;
};

const MultiLineGraph = (props) => {
  const { graphToolTip,
    data,
    height,
    xaxis,
    showXAxis = false,
    showYAxis = false,
    yTickFormatter,
    xTickFormatter = dateTickFormatter,
    customTick,
    entities = [],
    legendOnTop = false,
    grid = { vertical: false, horizontal: true } } = props;
  // get all variables except the xaxis
  const lines = Object.keys(data[0]).filter(el => el !== xaxis);

  if (!lines) {
    return null;
  }

  return (
    <KnotchGraph validate={validateTimeseries} {...props}>
      <GraphContainer height={height} entityLines={lines}>
        <ResponsiveContainer width="100%" height="100%" margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
          <LineChart data={data}>
            {legendOnTop && entities.length > 1 ? (
              <Legend
                verticalAlign="top"
                align="center"
                height={45}
                wrapperStyle={{ top: '-30px' }} // Places the legend outside the main container
                content={<EntityLegend entities={entities} top />}
              />) : null}
            { graphToolTip && <Tooltip content={graphToolTip} entities={entities} />}
            { showXAxis &&
            <XAxis
              dataKey={xaxis} tickLine={false}
              tickFormatter={xTickFormatter}
              tick={customTick}
              width={0}
            />}
            { showYAxis &&
            <YAxis
              tickFormatter={yTickFormatter}
              tickLine={false}
              width={35}
            />}
            <CartesianGrid stroke="#2B4F70" vertical={grid.vertical} horizontal={grid.horizontal} />
            {lines.map(entityId =>
              <Line
                type="monotone"
                stroke="#2D8BFF"
                className={`line_${entityId}`}
                key={`line_${entityId}`}
                dataKey={entityId}
                strokeWidth={1.5}
                dot={{ r: 2 }}
                entityName={getEntityName(entityId, entities)}
              />)}
            {!legendOnTop && entities.length > 1 ? (
              <Legend
                verticalAlign="bottom"
                align="center"
                height={36}
                wrapperStyle={{ bottom: '-20px' }}
                content={<EntityLegend entities={entities} />}
              />) : null}
          </LineChart>
        </ResponsiveContainer>
      </GraphContainer>
    </KnotchGraph>
  );
};

export default MultiLineGraph;
